import {Outlet} from "react-router-dom";

import React from 'react';

const Base = () => {
    return (
        <Outlet/>
    );
};

export default Base;